import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useCart } from '../../hooks/useCart';
import { getProductImage } from '../../utils/imageStorage';
import LocalImageUploader from '../../components/feature/LocalImageUploader';

export default function ProduitSapinsNoelLivrePliePiecesUniques() {
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState('pompon-rouge');
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const productId = 'sapins-noel-livre-plie-pieces-uniques';
  const defaultImage = 'https://public.readdy.ai/ai/img_res/6b58f710844c77176f6657812978a974.jpg';
  const [productImage, setProductImage] = useState<string>(defaultImage);
  const [showImageUploader, setShowImageUploader] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      const savedImage = await getProductImage(productId);
      if (savedImage) {
        setProductImage(savedImage);
      }
    };
    loadImage();
  }, []);

  const handleImageUpdate = (newImageUrl: string) => {
    setProductImage(newImageUrl || defaultImage);
    setShowImageUploader(false);
    window.location.reload();
  };

  const productVariants = {
    'pompon-rouge': {
      name: 'Sapin avec pompon rouge',
      price: 18,
      description: 'Sapin unique avec pompon rouge et décorations assorties',
      image: 'https://readdy.ai/api/search-image?query=Handmade Christmas tree made from folded book pages with red pompom on top, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal paper craft decoration with red pompom and special ornaments, vintage book pages carefully folded into tree shape, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornament, delicate craftsmanship, product photography style&width=1080&height=1080&seq=sapin-pompon-rouge-produit&orientation=squarish'
    },
    'pompon-blanc': {
      name: 'Sapin avec pompon blanc',
      price: 18,
      description: 'Sapin unique avec pompon blanc et décorations délicates',
      image: 'https://readdy.ai/api/search-image?query=Handmade Christmas tree made from folded book pages with white pompom on top, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal paper craft decoration with white pompom and delicate ornaments, vintage book pages carefully folded into tree shape, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornament, delicate craftsmanship, product photography style&width=1080&height=1080&seq=sapin-pompon-blanc-produit&orientation=squarish'
    }
  };

  const currentVariant = productVariants[selectedVariant as keyof typeof productVariants];

  const productImages = [
    'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/7c0bab232c89fefcab28a9096994e69d.png'
  ];

  const [mainImage, setMainImage] = useState(currentVariant.image);

  // Mettre à jour l'image principale quand la variante change
  useState(() => {
    setMainImage(currentVariant.image);
  }, [selectedVariant]);

  const handleAddToCart = () => {
    addToCart({
      id: `sapin-noel-pieces-uniques-${selectedVariant}`,
      name: currentVariant.name,
      price: currentVariant.price,
      image: currentVariant.image,
      description: currentVariant.description,
      link: '/produit-sapins-noel-livre-plie-pieces-uniques'
    }, quantity);
    
    // Feedback visuel
    const button = document.querySelector('.add-to-cart-btn') as HTMLButtonElement;
    if (button) {
      const originalText = button.innerHTML;
      button.innerHTML = '<i class="ri-check-line mr-2"></i>Ajouté au panier !';
      button.disabled = true;
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
    }
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="min-h-screen bg-[#F8EDEA]">
      <Header />
      
      {/* Breadcrumb */}
      <section className="py-4 bg-[#FAF9F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <a href="/" className="text-[#B97A72] hover:text-[#6B5E5A] transition-colors" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Accueil
            </a>
            <i className="ri-arrow-right-s-line text-[#6B5E5A]"></i>
            <a href="/boutique" className="text-[#B97A72] hover:text-[#6B5E5A] transition-colors" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Boutique
            </a>
            <i className="ri-arrow-right-s-line text-[#6B5E5A]"></i>
            <span className="text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Sapins de Noël en livre plié – Pièces uniques
            </span>
          </nav>
        </div>
      </section>

      {/* Product Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Image du produit */}
            <div>
              <div className="w-full h-[500px] bg-white rounded-lg overflow-hidden shadow-lg mb-4">
                <img
                  src={productImage}
                  alt="Sapins de Noël en livre plié - Pièces uniques"
                  className="w-full h-full object-contain"
                />
              </div>
              
              {/* Bouton pour modifier l'image */}
              <div className="text-center">
                <button
                  onClick={() => setShowImageUploader(!showImageUploader)}
                  className="bg-[#B97A72] text-white px-6 py-3 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <i className="ri-image-edit-line mr-2"></i>
                  {showImageUploader ? 'Fermer' : '📸 Modifier l\'image'}
                </button>
              </div>

              {/* Module de changement d'image */}
              {showImageUploader && (
                <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
                  <h3 className="text-xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                    Modifier l'image du produit
                  </h3>
                  <LocalImageUploader
                    productId={productId}
                    currentImage={productImage}
                    onImageUpdate={handleImageUpdate}
                  />
                </div>
              )}
            </div>

            {/* Product Info */}
            <div className="space-y-8">
              <div>
                <span className="text-sm text-[#B97A72] font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Collection de Noël • Sapin de Noël
                </span>
                <h1 className="text-4xl font-bold text-[#6B5E5A] mt-2 mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                  Sapins de Noël en livre plié – Pièces uniques ✨
                </h1>
                
                <div className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg p-6 mb-6">
                  <p className="text-lg text-[#6B5E5A] leading-relaxed italic mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                    <em>Un sapin de Noël poétique et unique</em> 🌟
                  </p>
                  <p className="text-[#6B5E5A] leading-relaxed mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Réalisé à partir d'un livre plié page après page, chaque sapin est entièrement fait à la main, puis décoré avec soin selon mon inspiration.
                  </p>
                  <p className="text-[#6B5E5A] leading-relaxed mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <strong>Hauteur :</strong> environ 18 cm<br />
                    <strong>Pompon supérieur :</strong> varie selon le modèle (rouge ou blanc)<br />
                    <strong>Décorations :</strong> strass, perles, fleurs, rubans, étoiles… chaque pièce est unique.
                  </p>
                  <div className="bg-[#EBD2CF] rounded-lg p-4 mb-4">
                    <p className="text-[#6B5E5A] leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      🎁 <strong>Idéal pour :</strong> décorer une table, une cheminée, une chambre d'enfant ou offrir un Noël rempli de poésie et de douceur.<br />
                      ♻️ <strong>Création écoresponsable :</strong> fabriquée à partir d'un livre recyclé.
                    </p>
                  </div>
                  <p className="text-[#B97A72] font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>
                    📌 Chaque sapin est unique. Sélectionnez la couleur du pompon pour choisir votre modèle.
                  </p>
                </div>
              </div>

              {/* Variantes */}
              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Couleur du pompon :
                </h3>
                <div className="space-y-3">
                  <label className="flex items-center p-4 bg-[#FAF9F8] border-2 border-[#EBD2CF] rounded-lg cursor-pointer hover:border-[#B97A72] transition-colors">
                    <input
                      type="radio"
                      name="variant"
                      value="pompon-rouge"
                      checked={selectedVariant === 'pompon-rouge'}
                      onChange={(e) => setSelectedVariant(e.target.value)}
                      className="mr-4 text-[#B97A72]"
                    />
                    <div className="flex-1">
                      <div className="flex justify-between items-center">
                        <span className="font-medium text-[#6B5E5A] flex items-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                          <div className="w-4 h-4 bg-red-500 rounded-full mr-3"></div>
                          Pompon rouge
                        </span>
                        <span className="text-2xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>
                          18€
                        </span>
                      </div>
                      <p className="text-sm text-[#6B5E5A] mt-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        Sapin unique avec pompon rouge et décorations assorties
                      </p>
                    </div>
                  </label>
                  
                  <label className="flex items-center p-4 bg-[#FAF9F8] border-2 border-[#EBD2CF] rounded-lg cursor-pointer hover:border-[#B97A72] transition-colors">
                    <input
                      type="radio"
                      name="variant"
                      value="pompon-blanc"
                      checked={selectedVariant === 'pompon-blanc'}
                      onChange={(e) => setSelectedVariant(e.target.value)}
                      className="mr-4 text-[#B97A72]"
                    />
                    <div className="flex-1">
                      <div className="flex justify-between items-center">
                        <span className="font-medium text-[#6B5E5A] flex items-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                          <div className="w-4 h-4 bg-white border-2 border-gray-300 rounded-full mr-3"></div>
                          Pompon blanc
                        </span>
                        <span className="text-2xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>
                          18€
                        </span>
                      </div>
                      <p className="text-sm text-[#6B5E5A] mt-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        Sapin unique avec pompon blanc et décorations délicates
                      </p>
                    </div>
                  </label>
                </div>
              </div>

              {/* Quantity */}
              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Quantité :
                </h3>
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 bg-[#EBD2CF] text-[#6B5E5A] rounded-full hover:bg-[#B97A72] hover:text-white transition-colors flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="text-xl font-semibold text-[#6B5E5A] w-12 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {quantity}
                  </span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className="w-10 h-10 bg-[#EBD2CF] text-[#6B5E5A] rounded-full hover:bg-[#B97A72] hover:text-white transition-colors flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-add-line"></i>
                  </button>
                </div>
              </div>

              {/* Price and Add to Cart */}
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <span className="text-3xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {(currentVariant.price * quantity).toFixed(2)}€
                  </span>
                </div>
                
                <button
                  onClick={handleAddToCart}
                  className="add-to-cart-btn w-full bg-[#B97A72] text-white px-8 py-4 rounded-full hover:bg-[#C49B86] transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2 inline-block">
                    <i className="ri-shopping-cart-line"></i>
                  </div>
                  Ajouter au panier
                </button>
              </div>

              {/* Product Details */}
              <div className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg p-6 space-y-4">
                <h3 className="text-xl font-semibold text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Informations supplémentaires :
                </h3>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-ruler-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Hauteur :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>environ 18 cm</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Fabrication :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>100% fait main en Provence</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-leaf-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Matières :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>livre recyclé, pompon, strass, perles, rubans</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-time-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Délai de préparation :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>2 à 4 jours</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-truck-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Livraison :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>Emballage soigné et protégé</span>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-alert-line text-[#B97A72] mr-3 mt-1"></i>
                    <div>
                      <span className="font-medium text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Entretien :</span>
                      <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>Ne pas exposer à l'humidité</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Poetic Quote */}
              <div className="text-center py-6">
                <p className="text-xl text-[#B97A72] font-medium italic" style={{ fontFamily: 'Allura, cursive' }}>
                  <em>Chaque page pliée raconte une histoire de Noël.</em> 💫
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Other Products */}
      <section className="py-16 bg-[#EBD2CF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
              Autres créations de Noël
            </h2>
            <p className="text-lg text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Découvrez toute la magie de la collection
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Handmade paper angel Christmas decoration made from folded book pages, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal Christmas craft with golden star accent, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornament, delicate craftsmanship, product photography style&width=1080&height=1080&seq=ange-25cm-related6&orientation=squarish"
                  alt="Ange à poser 25 cm"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Ange à poser – 25 cm
                </h3>
                <p className="text-[#6B5E5A] text-sm mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Poétique et lumineux ✨
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>20 €</span>
                  <a 
                    href="/produit-ange-a-poser-25cm"
                    className="bg-[#B97A72] text-white px-4 py-2 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    Voir
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Handmade paper book candle with white lace ribbon and pearl decorations, folded book pages creating candle shape, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal Christmas craft, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornament, delicate craftsmanship, product photography style&width=1080&height=1080&seq=bougie-related6&orientation=squarish"
                  alt="Bougie en livre plié"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Bougie en livre plié
                </h3>
                <p className="text-[#6B5E5A] text-sm mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Quand le papier s'illumine... 🕯️
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>20 €</span>
                  <a 
                    href="/produit-bougie-livre-plie"
                    className="bg-[#B97A72] text-white px-4 py-2 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    Voir
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-[#FAF9F8] rounded-lg border-2 border-[#B97A72] overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-square overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Small handmade paper angel Christmas decoration made from folded book pages with smiling face, centered perfectly on soft pink powder background #F3D9D9, square format 1080x1080px, artisanal Christmas craft, warm natural studio lighting, no shadows, clean minimalist composition, elegant handmade ornament, delicate craftsmanship, product photography style&width=1080&height=1080&seq=ange-joyeux-related6&orientation=squarish"
                  alt="Ange Joyeux Cœur"
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Ange "Joyeux Cœur"
                </h3>
                <p className="text-[#6B5E5A] text-sm mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Le petit ange au sourire radieux ✨
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>4€</span>
                  <a 
                    href="/produit-ange-joyeux-coeur"
                    className="bg-[#B97A72] text-white px-4 py-2 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    Voir
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href="/boutique"
              className="inline-flex items-center px-8 py-3 bg-[#B97A72] text-white font-semibold rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Allura, cursive' }}
            >
              Voir toute la boutique
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 transition-colors"
            >
              <i className="ri-close-line"></i>
            </button>
            <img
              src={selectedImage}
              alt="Image agrandie"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
